import { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import api from "@/lib/api";
import { Play, X } from "lucide-react";

export default function VideosPage() {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(null);
  useEffect(() => { api.get("/videos").then((r) => setVideos(r.data)); }, []);
  return (
    <div data-testid="videos-page">
      <PageHero eyebrow="Watch" title="VIDEOS" subtitle="Match highlights, coaching tips, and behind-the-scenes moments."
        image="https://images.unsplash.com/photo-1718247528937-07667d8906d9?w=1800" />
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {videos.map((v) => (
          <button
            key={v.id}
            data-testid={`video-card-${v.id}`}
            onClick={() => setActive(v)}
            className="group text-left relative aspect-video overflow-hidden bg-jpa-ink border border-jpa-border"
          >
            <img src={v.thumbnail_url} alt={v.title} className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
            <div className="absolute inset-0 grid place-items-center">
              <div className="w-16 h-16 rounded-full bg-jpa-accent grid place-items-center group-hover:scale-110 transition-transform">
                <Play className="w-6 h-6 text-jpa-ink ml-1" />
              </div>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
              <div className="text-[10px] font-bold uppercase tracking-widest text-jpa-accent">{v.category}</div>
              <div className="font-display text-2xl tracking-wider">{v.title}</div>
            </div>
          </button>
        ))}
      </div>

      {active && (
        <div data-testid="video-modal" className="fixed inset-0 z-50 bg-black/90 grid place-items-center p-4" onClick={() => setActive(null)}>
          <button data-testid="video-modal-close" onClick={() => setActive(null)} className="absolute top-4 right-4 w-10 h-10 grid place-items-center bg-white/10 text-white rounded-sm hover:bg-white/20">
            <X className="w-5 h-5" />
          </button>
          <div className="w-full max-w-5xl aspect-video" onClick={(e) => e.stopPropagation()}>
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${active.youtube_id}?autoplay=1`}
              title={active.title}
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </div>
  );
}
